export const RANGE_CONSTRAINTS = {
    FLEXIBLE: 'flexible',
    SAME_MONTH: 'same-month',
};

export const MODE_CONSTRAINTS = {
    SINGLE: 'single',
    RANGE: 'range',
    MULTIPLE: 'multiple',
};
